import type { SelectOptions } from "components/SelectUI/Select.model";
import type React from "react";
import { StyledInputSelectAdmin } from "./InputSelectAdmin.styled";

interface InputSelectProps {
  dataCy?: string;
  ariaLabel?: string;
  options: SelectOptions[];
  onSelectChange: React.ChangeEventHandler<HTMLSelectElement>;
  defaultValue?: string | number;
  disabled?: boolean;
  value?: string;
  id?: string;
}

export const InputSelectAdmin: React.FC<InputSelectProps> = ({
  defaultValue,
  dataCy,
  ariaLabel,
  options,
  onSelectChange,
  disabled,
  value,
  id,
}) => (
  <StyledInputSelectAdmin
    aria-label={ariaLabel || ""}
    dataCy={dataCy}
    defaultValue={defaultValue}
    disabled={disabled}
    id={id}
    options={options}
    value={value}
    onChange={onSelectChange}
  />
);
